document.addEventListener('DOMContentLoaded', function(){
  Search.init();
});

const Search = {
  selectors: {
    "searchInput": { selector: '#search-bar-input', type: 'single', scope: 'document' },
    "iconSearch": { selector: '.search-bar .icon-search', type: 'single', scope: 'document' },
    "formSearch": { selector: '.search-bar', type: 'single', scope: 'document' },
    "searchBar": { selector: '.search-bar', type: 'single', scope: 'document' },
    "closeSearch": { selector: '.icon-close-search', type: 'single', scope: 'document' },
    "quickSearchResultsWrap": { selector: '.quickSearchResultsWrap', type: 'single', scope: 'document' },
    "initialSearch": { selector: '.initial-search', type: 'single', scope: 'document' },
    "searchResultsContainer": { selector: '.search-results-container', type: 'single', scope: 'document' },
    "searchResults": { selector: '.search-results', type: 'single', scope: 'document' },
    "iconLoading": { selector: '.icon-loading', type: 'single', scope: 'document' }
  },

  init: function() {
    Utility.fetchEls(this.selectors, this);
    this.initEventListeners();
  },

  initEventListeners: function() {
    const { searchInput, searchBar, searchProduct, searchTrending, overlay, closeSearch, headerInput, quickSearchResultsWrap, iconLoading, initialSearch, searchResultsContainer } = this;

    // Toggle search results visibility
    if (searchInput) {
      searchInput.addEventListener('click', () => {
        quickSearchResultsWrap.style.display = 'block';
      });

      let typingTimer;
      const typingDelay = 1000;
      
      searchInput.addEventListener('keyup', () => {
        if (searchInput.value !== '') {
          iconLoading.style.display = 'block';
        } else {
          initialSearch.style.display = 'block';
          searchResultsContainer.style.display = 'none'
        }
        clearTimeout(typingTimer);
      
        typingTimer = setTimeout(() => {
          this.showResults(searchInput.value);
        }, typingDelay);
      });

      // Hide search form on clicking outside
      document.addEventListener('click', (e) => {
        if (!searchBar.contains(e.target) && !quickSearchResultsWrap.contains(e.target)) {
          document.documentElement.classList.remove('search-open');
          quickSearchResultsWrap.style.display = 'none';
        }
      });

      window.addEventListener('scroll', function() {
        quickSearchResultsWrap.style.display = 'none';
      });

      // Hide quick search results and close button
      closeSearch.addEventListener('click', () => {
        quickSearchResultsWrap.style.display = 'none';
      });
    } 
    
  },

  openSearchForm: function(icon) {
    const collectionHandle = 'best-sellers';
    const limit = 4;
    const grid = 4;
    
    fetch(`${window.router}/collections/${collectionHandle}?view=list_product&constraint=limit=${limit}+grid=${grid}+sectionId=search-form-product`)
      .then(response => response.text())
      .then(data => {
        if (url !== '') {
          document.querySelector('.search__products .products-grid').innerHTML = data;
        }
        this.applyAdditionalScripts();
      })
      .catch(err => console.error('Error fetching search results:', err));
  },

  fetchSearchResults: async function (query) {
    try {
      const response = await fetch(`/search?q=${query}&view=json`);
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("There was an error fetching the search results:", error);
      return null;
    }
  },

  // Function to show results
  showResults: async function (query) {
    const {initialSearch, searchResults, searchResultsContainer, iconLoading, searchInput} = this;
    const resultsObj = await this.fetchSearchResults(query);
    console.log('results', resultsObj);

    if (resultsObj && resultsObj.results_count !== 0) {
      searchResults.innerHTML = '';
      const allResultsBtn = document.querySelector('.all-results-btn');
      if (allResultsBtn) {
        allResultsBtn.remove();
      }
      initialSearch.style.display = 'none';
      resultsObj.results.forEach((result) => {
        if (!result.title.includes('Selkirk Labs')) {
          const resultCard = document.createElement('div');
          if (result.object_type == 'product') {
            resultCard.classList.add('product-card');
          } else {
            resultCard.classList.add('result-card');
          }
          let title = result.title;
          if (title.includes(' - Pickleball Paddle')) {
            title = title.replace(' - Pickleball Paddle', '');
          }
          resultCard.innerHTML = `
            <div class="img-container">
              <a href="${result.url}">
                <img src="${result.image}" class="product-card-img" alt="${result.image_alt}">
              </a>
            </div>
            <a href="${result.url}">
              <div class="product-content">
                <h3>${title}</h3>
              </div>
            </a>
          `;
          searchResults.appendChild(resultCard);
        }
      });
      const seeAllBtn = document.createElement('a');
      seeAllBtn.classList.add('all-results-btn');
      seeAllBtn.textContent = `See All ${resultsObj.results_count} Results`;
      seeAllBtn.href = resultsObj.url;
      searchResultsContainer.appendChild(seeAllBtn);
      iconLoading.style.display = 'none';
      console.log('searcch results container', searchResultsContainer);
      searchResultsContainer.style.display = 'block';
    } else {
      iconLoading.style.display = 'none';
      console.log('in the else');
        if (searchInput.value == '') {
          console.log('search empty');
          initialSearch.style.display = 'block';
          searchResultsContainer.style.display = 'none'
        }
      
      console.log("No results found or there was an error.");
    }
  }
};